import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-video\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.62,8.41l4.88,3.26a.39.39,0,0,1,0,.66l-4.88,3.26a.4.4,0,0,1-.41,0,.38.38,0,0,1-.21-.35V8.75a.41.41,0,0,1,.21-.36A.43.43,0,0,1,10.62,8.41ZM4,5V19H20V5ZM2,4A1,1,0,0,1,3,3H21a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol